var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_139)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.6217,
    y: 18.6217,
    width: 11.2434,
    height: 11.2434,
    transform: "rotate(-180 18.6217 18.6217)",
    fill: "#F6557F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.9999,
    y: 18.7143,
    width: 8.08122,
    height: 8.08122,
    transform: "rotate(-135 12.9999 18.7143)",
    fill: "#FF7FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 21.4326L7.37834 18.6218L18.6218 18.6218L13.0001 21.4326Z",
    fill: "#FF7095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6217 7.37826V5.69175L20.3082 7.37826L18.6217 7.37826Z",
    fill: "#FF7095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3783 7.37829V5.69177L5.69178 7.37829L7.3783 7.37829Z",
    fill: "#FF7095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6217 18.6217V20.3083L20.3082 18.6217H18.6217Z",
    fill: "#FF7095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37829 18.6218V20.3083L5.69178 18.6218H7.37829Z",
    fill: "#FF7095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5675 12.9999L7.37836 7.37815L7.37836 18.6216L4.5675 12.9999Z",
    fill: "#FF7095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 4.56738L7.37828 7.37824L18.6217 7.37824L13 4.56738Z",
    fill: "#FF7095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4327 12.9999L18.6219 7.3782L18.6219 18.6216L21.4327 12.9999Z",
    fill: "#FF7095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.93 13L20.3082 7.37831L18.6217 7.37831L21.4325 13L25.93 13Z",
    fill: "#FF91AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 25.93L18.6217 20.3082L18.6217 18.6217L13 21.4326L13 25.93Z",
    fill: "#FF91AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.070048 13L5.69182 7.37832L7.37833 7.37832L4.56748 13L0.070048 13Z",
    fill: "#FF91AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 0.0700989L18.6217 5.69187L18.6217 7.37838L13 4.56753L13.0001 0.0700989Z",
    fill: "#FF91AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.93 13L20.3082 18.6217L18.6217 18.6217L21.4326 13L25.93 13Z",
    fill: "#F36488"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 25.9299L7.37838 20.3081L7.37838 18.6216L13.0001 21.4325L13.0001 25.9299Z",
    fill: "#F36488"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0701169 13L5.69189 18.6217L7.3784 18.6217L4.56754 12.9999L0.0701169 13Z",
    fill: "#F36488"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 0.0700569L7.37831 5.69183L7.37831 7.37834L13 4.56749L13 0.0700569Z",
    fill: "#F36488"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_139"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 0.070034,
    width: 18.2858,
    height: 18.2857,
    rx: 2.28571,
    transform: "rotate(45 13 0.070034)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPink);
export default __webpack_public_path__ + "static/media/pink.f7c8767e58f5a9c0b7ae58cb17768e2a.svg";
export { ForwardRef as ReactComponent };